import { useCallback } from 'react'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

export function usePostalCodeViewedEvent() {
  const { pageData } = useGlobalContext()

  return useCallback(
    (inView: boolean) => {
      if (!inView) {
        return
      }

      dispatchAmplitudeEvent({
        eventName: 'Modal Viewed',
        eventData: {
          ...getStandardObject(pageData),
          modal_nome: 'Confira as melhores ofertas e fretes para sua região!',
        },
      })
    },
    [pageData]
  )
}
